import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';

@Component({
  selector: 'app-customer-demand',
  templateUrl: './customer-demand.component.html',
  styleUrl: './customer-demand.component.scss'
})
export class CustomerDemandComponent implements OnInit{

  constructor(
    private seoService: SeoService,
  ){}

  ngOnInit() {
    this.seoService.getSeo('report');
  }

}
